__turbopack_context__.v({
  "Image": "ImageBox-module-sass-module__KFcumG__Image",
  "ImageCont": "ImageBox-module-sass-module__KFcumG__ImageCont",
  "mobile-aspect-ratio-5-6": "ImageBox-module-sass-module__KFcumG__mobile-aspect-ratio-5-6",
});
